export default {"src":"/_next/static/image/public/images/flags/flag_1649.3a7c62372d2b6734514c8eab5bc5aa59.svg","height":16,"width":24};